
var Model = require("../types/Model.js");
var extender = Model.makeExtender;
// eslint-disable-next-line node/no-missing-require
const AsyncStorage = require("@react-native-async-storage/async-storage").default;
import { EMAIL_PATTERN } from "../../utils/constants.js";

module.exports = Model({
	name: "register",
	init: init,
	listeners: listeners,
	triggers: triggers,
	_hasLicenseChecked: false,
	_hasPrivacyPolicyChecked: false,
});

function init() {
	/**
	 * Checks to see what the last language (local storage) used was and uses
	 * to that if it exists, otherwise default is English ("en")
	 */
	var local = get_language();

	this.push({
		registering: false, // Whether the registration request is currently going through
		token: null,
		message: null,
		initial_email: "",
		localization: {}, // The current localization file
		language: local,
		license_accept: false,
		license_show: false,
		privacy_policy_show: false,
		save: false
	});

	function get_language() {
		AsyncStorage.getItem("local").then(function (language) {
			if (!language) return "en";
			return language;
		}).catch(function () {
			return "en";
		});
	}
}

function listeners() {
	return {
		"localization:updated": handle_localization_update,
		"querystring:updated": handle_querystring_update,
		"toast:updated": extender("toast"),
		"save:updated": extender("save")
	};
}

function triggers() {
	return {
		"validate": handle_trigger_validate,
		"register": handle_trigger_register,
		"license:show": handle_trigger_show,
		"license:hide": handle_trigger_hide,
		"privacy_policy:show": handle_trigger_policy_show,
		"checked": handle_checked
	};
}

function handle_trigger_show() {
	this.extend({
		license_show: true
	});
	this.emit("usermetrics:trigger:track", "view license agreement on registration screen");
}

function handle_trigger_hide() {
	this.extend({
		license_show: false
	});
	this.emit("usermetrics:trigger:track", "close license agreement on registration screen");
}

function handle_trigger_policy_show() {
	this.extend({
		privacy_policy_show: !this.data.privacy_policy_show
	});
	this?.data?.privacy_policy_show
		? this.emit(
			"usermetrics:trigger:track",
			"view privacy policy on registration screen"
		)
		: this.emit(
			"usermetrics:trigger:track",
			"close privacy policy on registration screen"
		);
}

function handle_trigger_validate(data) {
	this.emit("localization:trigger:set", {
		language: data.language
	});

	var email = data.email;
	
	var invalid = false;

	var invalidEmail = (!email) || (!email.match(EMAIL_PATTERN));

	if (invalidEmail)
		invalid = "error_register_email_validation";

	this.extend({
		message: invalid
	});
	var message = "register.emailerror";
	this.emit("toast:trigger:show", {
		content: message,
		style: "error"
	});
}

function handle_trigger_register(data) {
	var message = "";

	if (!this._hasLicenseChecked) {
		message = "schedule.schedulenolicense";
		this.emit("toast:trigger:show", {
			content: message,
			style: "error"
		});
		this.emit("usermetrics:trigger:track", "attempt to register with errors", {
			error: "didn't accept license"
		});
		return this.extend({
			message: message
		});
	}

	if (!this._hasPrivacyPolicyChecked) {
		message = "privacy_policy.schedulenouserpolicy";
		this.emit("toast:trigger:show", {
			content: message,
			style: "error"
		});
		this.emit("usermetrics:trigger:track", "attempt to register with errors", {
			error: "didn't accept privacy policy"
		});
		return this.extend({
			message: message
		});
	}

	var password = data.password;
	const passwordConfirm = data.password_confirm;
	var email = data.email;
	var fname = data.fname;
	var lname = data.lname;
	const language = data.language;

	if (!email) {
		message = "register.emailmissing";
		this.emit("toast:trigger:show", {
			content: message,
			style: "error"
		});
		this.emit("usermetrics:trigger:track", "attempt to register with errors", {
			error: "email missing"
		});
		return this.extend({
			message: "error_register_email_missing"
		});
	}

	if (!email.match(EMAIL_PATTERN)){
		message = "register.emailpattern";
		this.emit("toast:trigger:show", {
			content: message,
			style: "error"
		});
		this.emit("usermetrics:trigger:track", "attempt to register with errors", {
			error: "email pattern"
		});
		return this.extend({
			message: "error_register_email_pattern"
		});
	}

	if (!password) {
		message = "register.passwordmissing";
		this.emit("toast:trigger:show", {
			content: message,
			style: "error"
		});
		this.emit("usermetrics:trigger:track", "attempt to register with errors", {
			error: "password missing"
		});
		return this.extend({
			message: "error_register_password_missing"
		});
	}

	if (!passwordConfirm || password !== passwordConfirm) {
		message = "register.passwordmismatch";
		this.emit("toast:trigger:show", {
			content: message,
			style: "error"
		});
		this.emit("usermetrics:trigger:track", "attempt to register with errors", {
			error: "password mismatch"
		});
		return this.extend({
			message: "error_register_password_confirm_mismatch"
		});
	}

	var emailArr = email.split("@");
	var emailStr = emailArr[0];
	if (password.includes(fname) || password.includes(lname) || password.includes(emailStr)){
		message = "myprofile.invalidnameinclusion";
		this.emit("toast:trigger:show", {
			content: message,
			style: "error"
		});
		this.emit("usermetrics:trigger:track", "attempt to register with errors", {
			error: "password includes name"
		});
		return this.extend({
			message: "error_register_name"
		});
	}

	if (!fname) {
		message = "register.fnamemissing";
		this.emit("toast:trigger:show", {
			content: message,
			style: "error"
		});
		this.emit("usermetrics:trigger:track", "attempt to register with errors", {
			error: "fname missing"
		});
		return this.extend({
			message: "error_register_fname_missing"
		});
	}

	if (!lname) {
		message = "register.lnamemissing";
		this.emit("toast:trigger:show", {
			content: message,
			style: "error"
		});
		this.emit("usermetrics:trigger:track", "attempt to register with errors", {
			error: "lname missing"
		});
		return this.extend({
			message: "error_register_lname_missing"
		});
	}

	if (!language) {
		message = "register.languagemissing";
		this.emit("toast:trigger:show", {
			content: message,
			style: "error"
		});
		this.emit("usermetrics:trigger:track", "attempt to register with errors", {
			error: "language missing"
		});
		return this.extend({
			message: "error_register_language_missing"
		});
	}

	this.emit("save:trigger:start");

	this.extend({
		registering: true
	});

	this.api.auth
		.register(data)
		.then(handle_register_success.bind(this, data))
		.catch(handle_register_fail.bind(this));

	this.emit("usermetrics:trigger:track", "register");
}

/**
 * Called when registration went smoothly
 * @param  {Object} register_data  The original data used for registering. Must have `email` and `password`
 * @return {Promise}               Returns promise for logging in
 */
function handle_register_success(register_data) {
	var email = register_data.email;
	var password = register_data.password;
	return this.api.auth
		.login(email, password)
		.then(handle_login_success.bind(this));
}

/**
 * This gets caleld when registration fails
 * @param  {Error} error The error that occured
 */
function handle_register_fail(error) {
	this.emit("save:trigger:finish");

	console.error(error);

	var response = error.response;
	var status = error.status;
	var error_map = {
		402: "register.accounttaken",
		500: "register.registerfaild",
		undefined: "register.error0"
	};

	var errorMessage = null;
	var toast = error_map[status];
	if (status === 400) {
		if (response.message === "Password must not include 2 sequential characters from keyboard") {
			errorMessage = "error_register_sequential";
			toast = "myprofile.invalidsequential";
		} else if (response.message === "Password must not include 3 consecutive characters") {
			errorMessage = "error_register_consecutive";
			toast = "myprofile.invalidconescutive";
		} else if (response.message === "Password does not match basic rules") {
			errorMessage = "error_register_basic_rules";
			toast = "myprofile.invalidbasicrules";
		} else if (response.message === "Pasword confirm doesn't match") {
			errorMessage = "error_register_password_match";
			toast = "register.passwordmismatch";
		} else {
			errorMessage = `error_register_${response.message}`;
			toast = "register.registerfaild";
		}
	}

	this.extend({
		registering: false,
		message: errorMessage || toast
	});
	this.emit("toast:trigger:show", {
		content: toast,
		style: "error"
	});
}

/**
 * Called when logging in succeeds
 * @param  {Object} data The result of the login call. Contains `token`
 */
function handle_login_success(data) {
	this.emit("save:trigger:finish");

	var token = data.token;

	this.api.auth.auth(token).then(function(authData){
		this.extend({
			token: token,
			authData: authData,
			registering: false
		});
	}.bind(this));
}

/**
 * Handles changes in localization. Updates `localization` state.
 * @param  {Object} data The state of the Localization model. Contains `localization` map.
 */
function handle_localization_update(data) {
	this.extend({
		localization: data.localization,
		language: data.language
	});
}

/**
 * If there is a change in the query, this fucntion updates the 'initial_email'
 * variable
 * @param  {String} query Query string
 * @return {String}       'initial_email'
 */
function handle_querystring_update(query) {
	var email = query.email;
	if (email) this.extend({
		initial_email: email
	});
}

function handle_checked(data) {

	if (data.iAcceptAetonixLicense !== undefined) {
		this._hasLicenseChecked = data.iAcceptAetonixLicense;
		data.iAcceptAetonixLicense ?
			this.emit("usermetrics:trigger:track", "check off license agreement on registration screen")
			: this.emit("usermetrics:trigger:track", "uncheck license agreement on registration screen");
	}
	if (data.iAcceptUserPolicy !== undefined) {
		this._hasPrivacyPolicyChecked = data.iAcceptUserPolicy;
		data.iAcceptUserPolicy ?
			this.emit("usermetrics:trigger:track", "check off privacy policy on registration screen")
			: this.emit("usermetrics:trigger:track", "uncheck privacy policy on registration screen");
	}
}